module.exports = __webpack_public_path__ + "img/tangle-angel-logo.dc6af4c3.jpg";